<template>
  <page-outline :title="$t('contacts.edit_contact')">
    <template slot="pageContent">
      <b-row class="m-0 pb-3">
        <b-col cols="2">
          <back-button :returnUrl="returnUrl"></back-button>
        </b-col>
      </b-row>
      <form-accordion :title="$t('common.contact_ids')" :isTitleUpperCase="false" class="form-accordion-subtitle">
        <div class="form-group">
          <b-form-group class="" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              v-model="typeContact"
              :options="optionsTypeContact"
              :aria-describedby="ariaDescribedby"
              name="plain-inline"
              plain
            ></b-form-radio-group>
          </b-form-group>
        </div>

        <b-row class="form-group panel-subtitle">
          <b-col sm="5" class="mb-3">
            <form-write-group-label-input v-model="username" isMandatory
              :inputLabel="$t('common.nme')" :placeholderValue="$t('common.nme')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="5" class="mb-3">
            <form-write-group-label-input v-model="label" isMandatory
              :inputLabel="$t('common.als')" :placeholderValue="$t('common.als')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="form-group typeInd panel-subtitle" v-if="typeContact === '1'"
          @click="hideBlock($event)">
          <b-col sm="5" class="mb-3">
            <form-write-group-label-input v-model="identifier" isMandatory
              :inputLabel="$t('common.eml')" :placeholderValue="$t('common.eml')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="form-group typeCom panel-subtitle" v-else
          @click="hideBlock($event)">
          <b-col sm="5" class="mb-3">
            <form-write-group-label-input v-model="identifier" isMandatory
              :inputLabel="$t('common.srn')" :placeholderValue="$t('common.srn')">
            </form-write-group-label-input>
          </b-col>
        </b-row>

      </form-accordion>

      <hr class="mx-auto">

      <form-accordion :title="$t('common.srtp_adress')" class="form-accordion-subtitle" :isTitleUpperCase="false">
        <b-row class="typeCom panel-subtitle"
          @click="hideBlock($event)">
          <b-col sm="5" class="mb-3">
            <form-write-group-label-input v-model="iban" isMandatory
              :inputLabel="$t('contacts.ibn')" :placeholderValue="$t('contacts.ibn')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="5" class="mb-3">
            <form-write-group-label-input v-model="idProvider" isMandatory
              :inputLabel="$t('common.recipient_srtp_id_provider')" :placeholderValue="$t('common.recipient_srtp_id_provider')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <!-- <b-row class="typeCom panel-subtitle"
          @click="hideBlock($event)">
          <b-col sm="5" class="mb-3">
            <form-write-group-label-input v-model="idCompany"
              :inputLabel="$t('common.id_contact')" :placeholderValue="$t('common.recipient_srtp_id_company')">
            </form-write-group-label-input>
          </b-col>
        </b-row> -->
      </form-accordion>

      <!-- DRO 07/06/2023 Commenté car pas pertinent pour l'utilisation RTP
      <form-accordion :title="$t('common.formsSubTitle.bank_info')" class="form-accordion-subtitle" :isTitleUpperCase="false">
        <b-row class="form-group">
          <b-col sm="5" class="mb-3">
            <form-write-group-label-input isMandatory
              inputType="listeSelect"
              :inputLabel="$t('common.act')">
              <select class="form-control" id="sel4" readonly v-model="zone">
                <option v-for="country in countries" :key="country.id"
                  :value="country"
                  :disabled="country.disabled"
                  :selected="country.selected">
                  {{ $t('zoneCodes.' + country.label) }}
                </option>
              </select>
            </form-write-group-label-input>
          </b-col>
          <b-col sm="5" class="mb-3" v-for="accountLabel in zone.accountLabel" :key="accountLabel">
            <form-write-group-label-input v-model="zone.values[accountLabel]" isMandatory
              :inputLabel="$t(accountLabel)"
              :placeholderValue="$i18n.t(accountLabel)">
            </form-write-group-label-input>
          </b-col>
        </b-row>

        <div v-if="this.$engine.user.currentService.id === '2'">
          <b-row class="form-group panel-subtitle">
            <b-col sm="5" class="mb-3">
              <form-write-group-label-input v-model="mandatId"
                :inputLabel="$t('bank_accounts.mandat_id')"
                :placeholderValue="$i18n.t('bank_accounts.mandat_id')">
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row class="form-group panel-subtitle">
            <b-col sm="5" class="mb-3">
              <form-write-group-label-input v-model="mandatDate"
                inputType="date"
                :inputLabel="$t('bank_accounts.mandat_date')"
                :placeholderValue="$i18n.t('bank_accounts.mandat_date')">
              </form-write-group-label-input>
            </b-col>
          </b-row>
        </div>
      </form-accordion>
      -->
      <hr class="mx-auto">


      <form-accordion :title="$t('common.formsSubTitle.extra_info')" class="form-accordion-subtitle" :isTitleUpperCase="false">
        <b-row class="form-group panel-subtitle">
          <b-col sm="5" class="mb-3">
            <form-write-group-label-input v-model="phoneNumber"
              :inputLabel="$t('common.phn')" :placeholderValue="$t('common.phn')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="5" class="mb-3">
            <form-write-group-label-input v-model="address"
              :inputLabel="$t('common.adrs')" :placeholderValue="$t('common.adrs')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="form-group panel-subtitle">
          <b-col sm="5" class="mb-3">
            <form-write-group-label-input v-model="city"
              :inputLabel="$t('common.cty')" :placeholderValue="$t('common.cty')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="5" class="mb-3">
            <form-write-group-label-input v-model="zipCode"
              :inputLabel="$t('common.zp_code')" :placeholderValue="$t('common.zp_code')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="panel-subtitle">
          <b-col sm="5" class="mb-3">
            <form-write-group-label-input v-model="country"
              :inputLabel="$t('common.ctry')" :placeholderValue="$t('common.ctry')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>
      <b-row class="form-group justify-content-end mr-5">
        <b-col lg="2" cols="4">
          <b-button variant="primary" size="lg"
            @click="changeContact">
            <i class="fa-light fa-floppy-disk" size="17px"></i>
            <span>{{ $t('common.sve') }}</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from '@/components/common/backButton.vue'

import {createForeignIban, extractForeignIban} from '@/helpers/format'
import {loadPage} from '@/helpers/routing'
import {validateAccountFormat, validateEmail, validateIBAN, validateIBANRIBKey, validateSIREN, validatePhoneNumber} from '@/helpers/validator'

export default {
  name: 'EditContact',
  components: {
    'back-button': backButton,
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      iban: '',
      id: '',
      idCompany: '',
      idProvider:'',
      identifier: '',
      username: '',
      label: '',
      phoneNumber: '',
      address: '',
      city: '',
      zipCode: '',
      country: '',
      typeContact: '',
      zone: {},
      zoneCode: '',
      countries: '',
      countryPicker: '',
      returnUrl: '/contacts/',
      optionsTypeContact: []
    }
  },
  created () {
    this.optionsTypeContact = [
      { text: this.$i18n.t('common.indiv'), value: '1'},
      { text: this.$i18n.t('common.cmpny_accnt'), value: '2'},
    ]
    this.id = this.$settings.currentContact.id
    this.username = this.$settings.currentContact.name
    this.identifier = this.$settings.currentContact.identifier
    this.label = this.$settings.currentContact.label
    this.phoneNumber = this.$settings.currentContact.phoneNumber
    this.address = this.$settings.currentContact.address
    this.city = this.$settings.currentContact.city
    this.zipCode = this.$settings.currentContact.zipCode
    this.country = this.$settings.currentContact.country
    this.typeContact = this.$settings.currentContact.typeContact
    this.zone = this.$engine.bankAccounts.getZoneData(this.$settings.currentContact.zoneCode)
    this.zoneCode = this.zone.label
    this.iban= this.$settings.currentContact.iban
    this.idCompany= this.$settings.currentContact.idCompany
    this.idProvider= this.$settings.currentContact.idProvider

    /** TLV 19/03/2020
    * On extrait les donn�es du faux IBAN en base en vraies donn�es bancaires,
    * en fonction du pays, dans une variable locale appel�e extractedBankData
    */
    let extractedBankData = {}
    if (this.zoneCode !== '' && this.$settings.currentContact.iban !== '') {
      extractedBankData = extractForeignIban(this.$settings.currentContact.iban, this.zoneCode)
    }
    /** TLV 19/03/2020
    * On cr�� une variable locale json, qui va �tre int�gr�e dans this.zone et dans that.countries,
    * qui contient les valeurs actuelles du json pour l'utilisateur s�lectionn�
    */
    let datavalues = {}
    for (var bankData in extractedBankData) {
      datavalues[extractedBankData[bankData].labelId] = extractedBankData[bankData].value
    }
    this.zone.values = datavalues
    let that = this
    let label = []
    that.countries = this.$engine.bankAccounts.getZoneCode()
    for (var country in that.countries) {
      if (that.countries[country].label === this.zoneCode) {
        that.countries[country].values = datavalues
      }
    }
    that.countries.forEach((x, y) => {
      label.push(x.label)
    })
    that.countryPicker = this.$f7.picker({
      input: '#ListCountry',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: label
        }
      ],
      onClose: function (p) {
        that.zoneCode = p.value[0]
        that.zone = that.countries.filter(function (country) {
          return country.label === p.value[0]
        })[0]
      }
    })
  },
  methods: {
    changeContact () {
      const that = this

      const regexName = /^[\p{L}\p{N}\p{M}][\p{L}\p{N}\p{M}\s'-]*$/u
      const regexBIC = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/

      // Check input formats
      for (var i = 0; i < this.zone.accountNumberField; i++) {
        if (this.zone.values[this.zone.accountLabel[i]] != null && this.zone.values[this.zone.accountLabel[i]]) {
          if (validateAccountFormat(this.zone.values[this.zone.accountLabel[i]], this.zone.regexControl[i]) === null) {
            this.$f7.alert(
                this.$i18n.t('errors.change_to_valid',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])}),
                this.$i18n.t('errors.invalid_data_format',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])})
            )
            return
          }
        }
      }

      if (this.identifier.length > 0 && this.typeContact === '1') {
        if (validateEmail(this.identifier) === null) {
          this.$f7.alert(
              this.$i18n.t('errors.change_to_valid',
                {invaliddata: this.$i18n.t('common.eml_adrs')}),
              this.$i18n.t('errors.invalid_data_format',
                {invaliddata: this.$i18n.t('common.eml_adrs')})
          )
          return
        }
      }
      if (this.identifier.length > 0 && this.typeContact === '2') {
        if (validateSIREN(this.identifier) === null) {
          this.$f7.alert(
              this.$i18n.t('errors.change_to_valid',
                {invaliddata: this.$i18n.t('common.srn')}),
              this.$i18n.t('errors.invalid_data_format',
                {invaliddata: this.$i18n.t('common.srn')})
          )
          return
        }
      }
      if (this.iban.length === 0) {
        this.$f7.alert(
          '',
          this.$i18n.t('errors.missing_label', {
            invaliddata: this.$i18n.t('contacts.ibn'),
          })
        )
        return
      }

      if (this.idProvider.length === 0) {
        this.$f7.alert(
          '',
          this.$i18n.t('errors.missing_label', {
            invaliddata: this.$i18n.t('common.my_provider'),
          })
        )
        return
      }

      if (this.iban.length > 0) {
        if (validateIBAN(this.iban) === false || validateIBANRIBKey(this.iban) === false) {
          this.$f7.alert(
            this.$i18n.t('errors.chng_the_iban_to_vld_frmt'),
            this.$i18n.t('errors.invalid_data_format', {
              invaliddata: this.$i18n.t('contacts.ibn'),
            })
          )
          return
        }
      }

      if (this.phoneNumber.length > 0) {
        if (validatePhoneNumber(this.phoneNumber) === null) {
          this.$f7.alert(
              this.$i18n.t('errors.change_to_valid',
                {invaliddata: this.$i18n.t('common.phn_nbr')}),
              this.$i18n.t('errors.invalid_data_format',
                {invaliddata: this.$i18n.t('common.phn_nbr')})
          )
          return
        }
      }
      if (that.username.length === 0) {
        this.$f7.alert(
          '',
          this.$i18n.t('errors.missing_label',
            {invaliddata: this.$i18n.t('common.nme')})
        )
        return
      }

      if (!regexName.test(this.username)) {
        this.$f7.alert(
            this.$i18n.t('errors.change_to_valid',
              {invaliddata: this.$i18n.t('common.nme')}),
            this.$i18n.t('errors.invalid_data_format',
              {invaliddata: this.$i18n.t('common.nme')})
        )
        return
      }

      if (that.label.length === 0) {
        this.$f7.alert(
          '',
          this.$i18n.t('errors.missing_label',
            {invaliddata: this.$i18n.t('common.als')})
        )
        return
      }

      if (!regexName.test(this.label)) {
        this.$f7.alert(
            this.$i18n.t('errors.change_to_valid',
              {invaliddata: this.$i18n.t('common.als')}),
            this.$i18n.t('errors.invalid_data_format',
              {invaliddata: this.$i18n.t('common.als')})
        )
        return
      }

      if (this.idProvider && !regexBIC.test(this.idProvider)) {
        this.$f7.alert(
            this.$i18n.t('errors.change_to_valid',
              {invaliddata: this.$i18n.t('common.my_provider')}),
            this.$i18n.t('errors.invalid_data_format',
              {invaliddata: this.$i18n.t('common.my_provider')})
        )
        return
      }

      if (this.address && !regexName.test(this.address)) {
        this.$f7.alert(
          this.$i18n.t('errors.change_to_valid',
          {invaliddata: this.$i18n.t('common.adrs')}),
          this.$i18n.t('errors.invalid_data_format',
          {invaliddata: this.$i18n.t('common.adrs')})
        )
        return
      }


      if (this.city && !regexName.test(this.city)) {
        this.$f7.alert(
          this.$i18n.t('errors.change_to_valid',
          {invaliddata: this.$i18n.t('common.cty')}),
          this.$i18n.t('errors.invalid_data_format',
          {invaliddata: this.$i18n.t('common.cty')})
        )
        return
      }

      if (this.zipCode && !regexName.test(this.zipCode)) {
        this.$f7.alert(
          this.$i18n.t('errors.change_to_valid',
          {invaliddata: this.$i18n.t('common.zp_code')}),
          this.$i18n.t('errors.invalid_data_format',
          {invaliddata: this.$i18n.t('common.zp_code')})
        )
        return
      }

      if (this.country && !regexName.test(this.country)) {
        this.$f7.alert(
          this.$i18n.t('errors.change_to_valid',
          {invaliddata: this.$i18n.t('common.ctry')}),
          this.$i18n.t('errors.invalid_data_format',
          {invaliddata: this.$i18n.t('common.ctry')})
        )
        return
      }

      /* TLV 18/03/2020
      * Cr�ation d'un "faux IBAN" pour enregistrer en base
      */
      /*DRO 07/06/2023 Commenté car pas pertinent pour l'utilisation RTP
      let localIban = createForeignIban(zone)*/

      // Edit contact
      this.$engine.contacts.update({
        idContact: this.id,
        identifier: this.identifier,
        name: this.username,
        iban: this.iban,
        label: this.label,
        phoneNumber: this.phoneNumber,
        address: this.address,
        city: this.city,
        zipCode: this.zipCode,
        country: this.country,
        typeContact: this.typeContact,
        zoneCode: this.zone.label,
        idCompany: this.idCompany,
        idProvider: this.idProvider
      })
      .then(() => {
        that.$f7.modal({
          title: that.$i18n.t('success.updated_success',
            {data: that.$i18n.t('common.contact_label')}),
          text: '<span class="preloader"></span>'
        })
        setTimeout(function () {
          that.$f7.closeModal()
          that.identifier = ''
          that.username = ''
          that.label = ''
          that.typeContact = '1'
          that.$bus.$emit('refresh-cache-contacts')
          that.$$(document).off('taphold', '.testTap')
          loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
        }, 2000)
      })
      .catch(err => {
        this.handleError(err) // mixins errorHandlerMixins
      })
    },
    countriesPicker (e) {
      e.stopPropagation()
      this.countryPicker.open()
    }
  }
}
</script>
